<template lang="pug">
	div(style="border: 1px solid #f0f0f0;padding: 10px;")
		.card.mb-2
			.card-header.bg-info.text-white(@click="verMenu = !verMenu", style="cursor: pointer;")
				b Selección rápida
				button.close(@click="verMenu = !verMenu")
					span.fa.fa-caret-down(v-if="!verMenu")
					span.fa.fa-caret-up(v-if="verMenu")
			.card-body(v-show="verMenu")
				.row
					.col
						.form-group
							label Desde
							datepicker(
								:monday-first="true",
								:bootstrap-styling="true",
								v-model="filtro.fecha_inicio"
								:language="$dateLang"
							)
					.col
						.form-group
							label Hasta
							datepicker(
								:monday-first="true",
								:bootstrap-styling="true",
								v-model="filtro.fecha_fin",
								:language="$dateLang"
							)
				.row
					.col
						select-dias(:dias.sync="filtro.dias_semana")
					.col
						.form-group
							label Excluír festivos
							br
							.btn-group
								button.btn(:class="(filtro.excluir.indexOf('local') < 0) ? '' : 'btn-primary'", @click="toggleExcluir('local')") Locales
								button.btn(:class="(filtro.excluir.indexOf('comunidad') < 0) ? '' : 'btn-primary'", @click="toggleExcluir('comunidad')") Regionales
								button.btn(:class="(filtro.excluir.indexOf('nacional') < 0) ? '' : 'btn-primary'", @click="toggleExcluir('nacional')") Nacionales
			.card-footer(v-show="verMenu")
				button.m-1.btn.btn-warning(@click="seleccionar")
					span.fa.fa-check
					| Seleccionar
				button.m-1.btn.btn-danger(@click="quitar")
					span.fa.fa-trash
					| Quitar

		
		div.text-center.p-3
			.input-group
				.input-group-prepend
					button.btn.btn-primary(@click="setAno(anoActual - 1)")
						span.fa.fa-caret-left
				.input-group-append
					.input-group-text {{anoActual}}
				.input-group-append
					button.btn.btn-primary(@click="setAno(anoActual + 1)")
						span.fa.fa-caret-right
				
		.row
			.col-xs-4.col-sm-4.col-md-4.col-lg-4.col-xl-4(v-for="mes in listadoMeses", :key="mes.nombre")
				table.table.table-condensed.table-bordered
					thead
						tr.bg-dark.text-white
							th(colspan="7", style="text-align:ceneter;") {{mes.nombre}}
						tr
							th(v-for="(d, i) in Array(7)", :key="mes.nombre + ' - ' + i", style="padding: 1px;text-align:center;") {{semana[i]}}
						tr(v-for="semana in mes.semanas")
							td(
								v-for="dia in semana",
								:key="dia.fecha.getTime()",
								style="text-align:center;padding: 1px;"
								:style="(dia.activo) ? {cursor: 'pointer'} : {}"
								:class="(miSeleccion.indexOf(dia.fecha.getTime()) >= 0) ? 'bg-warning' : ''",
								@click="toggleDia(dia)"
							)
								span(v-if="dia.activo") {{dia.fecha.getDate()}}
								span(v-if="!dia.activo", style="opacity:0.3;") {{dia.fecha.getDate()}}

</template>

<script>
import SelectDias from './select-dias.vue'
import axios from 'axios'
export default {
	props: ['seleccion', 'ano', 'to', 'from', 'error', 'menu'],
	components: {
		'select-dias': SelectDias
	},
	data () {
		return {
			miSeleccion: [],
			semana: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			filtro: {
				fecha_inicio: null,
				fecha_fin: null,
				excluir: [],
				dias_semana: []
			},
			anoActual: new Date().getFullYear(),
			verMenu: false,
			festivos: new Map()
		}
	},
	created () {
		this.miSeleccion = (!this.seleccion) ? [] : [].concat(this.seleccion)
		this.verMenu = (typeof this.menu === 'boolean') ? this.menu : false
		this.anoActual = (typeof this.ano === 'number') ? this.ano : new Date().getFullYear()
		this.getFestivos()
	},
	watch: {
		seleccion: function (newValue) {
			this.miSeleccion = [].concat(newValue)
		},
		ano: function (newValue) {
			this.getFestivos()
		}
	},
	computed: {
		listadoMeses () {
			// En función del año, construímos los meses
			// cada mes contendrá tantos arrays como semanas tenga
			// y cada semana será un array de los días que la contiene
			const meses = []
			const fecha = new Date(this.anoActual, 0, 1, 0, 0, 0, 0)

			// vemos en que día empieza el año (domingo = 0, lunes = 1, martes = 2....)
			// como en españa las semanas empiezan el lunes, restaremos uno al día de la semana y los negativos serán un 7
			let mesActual = null
			let mes = null
			let contador = 0
			while (fecha.getFullYear() === this.anoActual) {
				if (++contador === 500) {
					return meses
				}
				let semana = []
				if (mesActual !== fecha.getMonth()) {
					mes = {
						nombre: this.meses[fecha.getMonth()],
						diaIni: new Date(fecha.getTime()),
						semanas: []
					}

					meses.push(mes)
					mesActual = fecha.getMonth()
					fecha.setDate(1)

					// Calculamos el offset
					const diasOffset = (fecha.getDay() === 0) ? 6 : fecha.getDay() - 1
					if (diasOffset !== 0) {
						for (let i = 0; i < diasOffset; i++) {
							semana.push({
								activo: false,
								fecha: new Date(fecha.getTime() - ((diasOffset - i) * 86400000))
							})
						}
					}
				}

				let diaSem = (fecha.getDay() === 0) ? 6 : fecha.getDay() - 1
				for (let i = diaSem; i <= 6; i++) {
					const activo = ((this.to && this.to < fecha) || (this.from && this.from > fecha)) ? false : (fecha.getMonth() === mesActual)
					semana.push({
						activo: activo,
						fecha: new Date(fecha.getTime())
					})
					fecha.setDate(fecha.getDate() + 1)
				}

				// Si ha terminado el mes, comprobamos en que día de la semana lo hace para rellenarlo con días vacíos
				if (fecha.getMonth() !== mesActual) {
					const diaFin = (fecha.getDay() === 0) ? 6 : fecha.getDay() - 1
					if (diaFin !== 6) {
						let d = 1
						for (let i = diaFin - 1; i >= 6; i++) {
							semana.push({
								activo: false,
								fecha: new Date(fecha.getTime() + (d * 86400000))
							})
							d++
						}
					}
				}
				mes.semanas.push(semana)
			}
			// meses.push(mes)

			return meses
		}
	},
	methods: {
		getFestivos () {
			axios.get('gestion-emisoras/php/api/bloques/get-festivos.php?ano=' + this.anoActual)
				.then(res => {
					this.festivos = new Map()
					for (let i = 0; i < res.data.festivos.length; i++) {
						this.festivos.set(res.data.festivos[i].dia * 1000, res.data.festivos[i])
					}
				})
				.catch(this.$responseError)
		},
		setAno (ano) {
			this.anoActual = ano
			this.getFestivos()
		},
		toggleExcluir (tipo) {
			const idx = this.filtro.excluir.indexOf(tipo)
			if (idx < 0) {
				this.filtro.excluir.push(tipo)
			} else {
				this.filtro.excluir.splice(idx, 1)
			}
		},
		toggleDia (dia) {
			if (!dia.activo) {
				return
			}
			const idx = this.miSeleccion.indexOf(dia.fecha.getTime())
			if (idx >= 0) {
				this.miSeleccion.splice(idx, 1)
			} else {
				this.miSeleccion.push(dia.fecha.getTime())
			}

			this.update()
		},
		seleccionar (reset) {
			reset = (reset !== false)
			if (reset) {
				this.seleccionDias = []
			}

			if (!this.filtro.fecha_inicio || !this.filtro.fecha_fin) {
				this.$error('Error', 'Debes seleccionar una fecha de inicio y una fecha de fin')
				return
			}

			if (this.filtro.fecha_inicio >= this.filtro.fecha_fin) {
				this.$error('Error', 'La fecha de inicio tiene que ser menor que la de fin')
				return
			}

			if (this.filtro.dias_semana.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día de la semana')
				return
			}

			let fecha = new Date(this.filtro.fecha_inicio.getTime())
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			fecha.setMilliseconds(0)

			while (fecha.getTime() <= this.filtro.fecha_fin.getTime()) {
				const dia = (fecha.getDay() === 0) ? 6 : fecha.getDay() - 1
				const esFestivo = (this.festivos.has(fecha.getTime())) ? this.festivos.get(fecha.getTime()).tipo : null
				const activo = ((this.to && this.to > fecha) || (this.from && this.from < fecha))
				if (activo && this.filtro.dias_semana.indexOf(dia) >= 0 && this.filtro.excluir.indexOf(esFestivo) < 0) {
					const unix = new Date(fecha.getTime()).getTime()
					if (this.miSeleccion.indexOf(unix) < 0) {
						this.miSeleccion.push(unix)
					}
				}
				fecha.setDate(fecha.getDate() + 1)
			}
			this.update()
		},
		quitar () {
			if (!this.filtro.fecha_inicio || !this.filtro.fecha_fin) {
				this.$error('Error', 'Debes seleccionar una fecha de inicio y una fecha de fin')
				return
			}

			if (this.filtro.fecha_inicio >= this.filtro.fecha_fin) {
				this.$error('Error', 'La fecha de inicio tiene que ser menor que la de fin')
				return
			}

			if (this.filtro.dias_semana.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día de la semana')
				return
			}

			let fecha = new Date(this.filtro.fecha_inicio.getTime())
			fecha.setHours(0)
			fecha.setMinutes(0)
			fecha.setSeconds(0)
			fecha.setMilliseconds(0)

			while (fecha.getTime() <= this.filtro.fecha_fin.getTime()) {
				const dia = (fecha.getDay() === 0) ? 6 : fecha.getDay() - 1
				const esFestivo = (this.festivos.has(fecha.getTime())) ? this.festivos.get(fecha.getTime()).tipo : null
				if (this.filtro.dias_semana.indexOf(dia) >= 0 && this.filtro.excluir.indexOf(esFestivo) < 0) {
					const unix = new Date(fecha.getTime()).getTime()
					const idx = this.miSeleccion.indexOf(unix)
					if (idx >= 0) {
						this.miSeleccion.splice(idx, 1)
					}
				}
				fecha.setDate(fecha.getDate() + 1)
			}

			this.update()
		},
		update () {
			this.$emit('update:seleccion', this.miSeleccion)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/utilidades/calendario-anual.vue